<template>
    <div>
        <div class="container">
            <div class="handle-box">
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="标题" align="center"></el-table-column>
                <el-table-column label="显示状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enable">已显示</span>
                        <span v-else>未显示</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button 
                            v-if="scope.row.enable"
                            type="text"
                            icon="el-icon-edit"
                            @click="enableEdit(scope.row)"
                        >不显示</el-button>
                        <el-button 
                            v-else
                            type="text"
                            icon="el-icon-edit"
                            @click="enableEdit(scope.row)"
                        >显示</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="类型：" prop="type">
                    <el-select v-model="form.type" class="handle-select">
                        <el-option
                        v-for="(child, index) in banners_type"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="路径：" prop="extra_info">
                    <el-input
                     v-model="form.extra_info" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/hemeraApiConfig'
export default {
    name: 'Newsmanage',
    data() {
        return {
            location_types: [
                {"label": "首页", "value": 1},
                {"label": "发现页", "value": 2}
            ],
            location_type: 1,
            banners_type: [],
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            loading: false,
            multipleSelection: [],
            delList: [],
            editVisible: false,
            is_add: false,
            form: {},
            submit_obj:{},
            rules: {
                Code: [{ required: true, message: "请填写code", trigger: "blur" }],
                SignName: [{ required: true, message: "请填写sign_name", trigger: "blur" }],
                AppKey: [{ required: true, message: "请填写app_key", trigger: "blur" }],
                AppSecret: [{ required: true, message: "请填写app_secret", trigger: "blur" }],
                TemplateCode: [{ required: true, message: "请填写模板格式", trigger: "blur" }],
                AllowCount: [{ required: true, message: "请填写允许次数", trigger: "blur" }]
            },
            idx: -1,
            id: -1
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        bannerType(id){
            var item = _.filter(this.banners_type, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            http.get("admin/articles/categories",{params: params}).then(function(res) {
                that.tableData = res.data.data;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.pageTotal = that.totalPages * that.page_size;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        //启用操作
        enableEdit(row){
            let that = this;
            let params = {}
            if(row.enable){
                params["enable"] = 0;
                that.$confirm('是否关闭显示?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.put("admin/articles/categories/"+row.id, params).then(function(res) {
                        // console.log(res);
                        if (res.data.status_code == 200) {
                            that.$message.success('关闭成功');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }else{
                params["enable"] = 1;
                that.$confirm('是否显示?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.put("admin/articles/categories/"+row.id, params).then(function(res) {
                        // console.log(res);
                        if (res.data.status_code == 200) {
                            that.$message.success('显示成功');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                http.delete("admin/banners/"+row.id).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        onInput(){
            this.$forceUpdate();
        },
        // 编辑操作
        handleEdit(row) {
            console.log(row);
            this.form = {
                id: row.id,
                enable: row.enable,
                img_path: row.img_path,
                extra_info: row.extra_info,
                type: parseInt(row.type)
            };
            this.is_add = false;
            this.editVisible = true;
        },
        //新增操作
        addEdit(){
            this.form = {
                enable: 0,
                img_path: '',
                extra_info: '',
                type: 1
            };
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        enable: that.form.enable,
                        img_path: that.form.img_path,
                        extra_info: that.form.extra_info,
                        location_type: that.form.location_type,
                        type: that.form.type
                    };
                    if(that.is_add){
                        http.post("admin/banners", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.currentPage = 1;
                                that.getData();
                            }
                        });
                    }else{
                        http.put("admin/banners/"+that.form.id, params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$set(that.tableData, that.idx, that.form);
                                that.$message.success(`修改成功`);
                            }
                        });
                    }
                    // console.log(params);
                    
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
</style>
